<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${userCount})` }}</span></v-toolbar-title
            >
            <v-combobox
                v-if="hasPermissionForAction(PermissionsConstants.USER, PermissionsConstants.SEARCH)"
                :items="searchHistory"
                :value="searchUserString"
                @input="controlSearchString($event)"
                item-text="keyword"
                id="searchInput"
                class="mt-6 mx-2"
                :placeholder="t('User name, position, phone, email, role')"
                prepend-inner-icon="search"
                flat
                solo
                dense
                clearable
            >
                <template slot="item" slot-scope="data">
                    <span
                        @click="updateUserSearchOnClick(data.item.keyword)"
                        style="width: 100%; height: 100%"
                        class="pa-2"
                        >{{ data.item.keyword }}</span
                    >
                </template>
            </v-combobox>
            <v-spacer v-else />
            <v-btn
                dark
                color="bal-red"
                class="px-2 ml-2"
                style="min-width: 0;"
                v-if="hasPermissionForAction(PermissionsConstants.USER, PermissionsConstants.CREATE)"
                @click.stop="openNewClientDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <user-view v-if="$route.name == 'user-view'"></user-view>
            <user-edit v-if="$route.name == 'user-edit'"></user-edit>
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <!-- Footer -->
        <page-footer />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import UserView from "../pages/users/user-view.vue";
import UserEdit from "../pages/users/user-edit.vue";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../store";
import { PermissionsConstants } from "@/permissions";

export default {
    components: {
        UserView,
        UserEdit,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async created() {
        await Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    destroyed() {
        if (this.searchUserString.length > 0) Store.commit("UserStore/resetUserSearch");
        document.removeEventListener("keydown", this.handleKeyboardListener);
        Store.commit("UserStore/setRequestSuccess", false);
        Store.commit("UserStore/setErrorMessage", "");
    },
    methods: {
        ...mapMutations("UserStore", ["resetActiveUser"]),
        ...mapActions("SearchHistoryStore", ["getSearchHistory"]),
        openNewClientDrawer() {
            this.$router.push({ name: "user-edit", params: { userId: "new" } });
        },
        updateUserSearch(value) {
            Store.commit("UserStore/updateUserSearch", { term: value });
            //this.updateUserSearch(value);
            Store.commit("UserStore/setRequestSuccess", false);
            Store.commit("UserStore/setErrorMessage", "");
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                this.resetActiveUser();
                this.$router.push({ name: "user-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                Store.commit("UserStore/updateUserSearch", {
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                this.activeUser &&
                Object.keys(this.activeUser).length > 0 &&
                this.activeUser.id !== "new" &&
                this.$route.name !== "user-edit"
            ) {
                let currentUserIndex = this.users.findIndex(p => p.id === this.activeUser.id);
                if (e.key === "ArrowUp") {
                    if (currentUserIndex !== 0) {
                        const newUserId = this.users[currentUserIndex - 1].id;
                        Store.dispatch("UserStore/getUserData", newUserId);
                        this.$router.push({ name: this.$route.name, params: { userId: newUserId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentUserIndex + 1 !== this.users.length) {
                        const newUserId = this.users[currentUserIndex + 1].id;
                        Store.dispatch("UserStore/getUserData", newUserId);
                        this.$router.push({ name: this.$route.name, params: { userId: newUserId } });
                    }
                }
            }
        },
        async updateUserSearchOnClick(value) {
            await Store.commit("UserStore/updateUserSearch", {
                term: value
            });
        },
        controlSearchString(value) {
            if (value == "") this.updateUserSearch(value);
        }
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("UserStore", ["drawerOpen", "searchUserString", "requestSuccess", "users", "activeUser"]),
        ...mapGetters("UserStore", ["userCount"]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
